import React from 'react';
import ReactDOM from 'react-dom';
import App from '$product/_init';

ReactDOM.render(<App />, document.getElementById('root'));
